import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { ActionLogResponseDto } from "../dto/super-admin/action-log-response-dto";
import { OperationLogResponseDto } from "../dto/super-admin/operation-log-reponse-dto";
import { ActionLogRequestPayload } from "../payload/super-admin/action-log-request-payload";
import { OperationLogRequestPayload } from "../payload/super-admin/operation-log-request-payload";

export class SuperAdminSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async getOperationLog(
    payload: OperationLogRequestPayload
  ): Promise<SATResult<OperationLogResponseDto, SATError>> {
    try {
      const response = await this.client.post(URLList.SUPER_ADMIN.OPERATION_LOG, payload);
      console.log("[SuperAdminSource] :: getOperationLog :: 운영 로그 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[SuperAdminSource] :: getOperationLog :: 운영 로그 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[SuperAdminSource] :: getOperationLog | ", satError);
      return SATResult.failure(satError);
    }
  }

  async getActionLog(
    payload: ActionLogRequestPayload
  ): Promise<SATResult<ActionLogResponseDto, SATError>> {
    try {
      const response = await this.client.post(URLList.SUPER_ADMIN.ACTION_LOG, payload);
      console.log("[SuperAdminSource] :: getActionLog :: 액션 로그 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[SuperAdminSource] :: getActionLog :: 액션 로그 조회 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[SuperAdminSource] :: getActionLog | ", satError);
      return SATResult.failure(satError);
    }
  }
}
